<template>
  <AppModal ref="modal" @close="$emit('close')">
    <h3 slot="modal-header" class="heading">Populate data for {{ data.school }}</h3>

    <template v-if="populated" slot="modal-body">
      <ul>
        <li>Data populated successfully!</li>

        <li v-if="createEventsSite">
          {{ eventsSiteText }}
        </li>

        <li v-if="createCatalogSite">
          {{ catalogSiteText }}
        </li>
      </ul>
    </template>

    <template v-else slot="modal-body">
      <div class="form-group">
        <label class="heading smaller-heading">Select Products</label>
        <Multiselect
          :value="selectedProducts"
          :options="productOptions"
          :custom-label="capitalize"
          :multiple="true"
          :searchable="false"
          :show-labels="false"
          placeholder="Select products"
          @input="updateSelectedProducts"
        />
      </div>

      <div class="form-group">
        <div class="switch flex-1">
          <label class="">
            <input
              v-model="createEventsSite"
              class="mr-1 align-top inputtrigger"
              type="checkbox"
              :disabled="!eventsSelected"
            />
            <span class="bmd-switch-track">
              <div class="ripple-container"></div>
            </span>
            <span>Create public events website (url will be {{ formattedSchool }}-events.coursedog.com)</span>
          </label>
        </div>
      </div>

      <div class="form-group">
        <div class="switch flex-1">
          <label class="">
            <input
              v-model="createCatalogSite"
              class="mr-1 align-top inputtrigger"
              type="checkbox"
              :disabled="!catalogSelected"
            />
            <span class="bmd-switch-track">
              <div class="ripple-container"></div>
            </span>
            <span>Create public catalog website (url will be {{ formattedSchool }}-catalog.coursedog.com)</span>
          </label>
        </div>
      </div>

      <div>
        <span>Note: The email notification setting will be set to off by default. </span>
      </div>
    </template>

    <template v-if="populated" slot="modal-footer">
      <AppButton @click="close">Done</AppButton>
    </template>

    <template v-else slot="modal-footer">
      <AppButton variant="secondary" @click="close">Cancel</AppButton>
      <AppButtonAsync :promise="populateData">Populate</AppButtonAsync>
    </template>
  </AppModal>
</template>

<script>
import { postPopulateSchool } from '@/api'
import Multiselect from '@/components/Multiselect'

const PRODUCT_OPTIONS = [
  'scheduling', 'events', 'curriculum', 'catalog',
]

export default {
  components: { Multiselect },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      productOptions: PRODUCT_OPTIONS,
      selectedProducts: this.data.products.slice(),
      createEventsSite: this.data.products.includes('events'),
      createCatalogSite: this.data.products.includes('catalog'),
      populated: false,
      response: null,
    }
  },
  computed: {
    eventsSelected () {
      return this.selectedProducts.includes('events')
    },
    catalogSelected () {
      return this.selectedProducts.includes('catalog')
    },
    eventsSiteText () {
      return this.response
        ? 'Public events site created successfully'
        : 'Error creating public events site'
    },
    catalogSiteText () {
      return this.response
        ? 'Public catalog site created successfully'
        : 'Error creating public catalog site'
    },
    formattedSchool () {
      const school = this.data.school
      return school.replace(/_/g, '-')
    },
  },
  methods: {
    async populateData () {
      this.response = await postPopulateSchool(
        { school: this.data.school },
        {
          products: this.selectedProducts,
          createEventsSite: this.createEventsSite,
          createCatalogSite: this.createCatalogSite,
        }
      )
      this.populated = true
    },
    updateSelectedProducts (value) {
      if (!value.includes('events')) this.createEventsSite = false
      if (!value.includes('catalog')) this.createCatalogSite = false
      this.selectedProducts = value
    },
    close () {
      if (!this.$refs.modal) return
      this.$refs.modal.close()
    },
  },
}
</script>

<style scoped>
.modal-backdrop >>> .modal-body {
  overflow: visible;
}
</style>
